


















import { Component, Mixins, Ref } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types";
import { SortWarekiDate } from "#/utility/appSort";
import AxiosMixin from "@/mixins/axiosMixin";
import BaseReportList from "@/components/patient/BaseReportList.vue";
import { ConferenceReport } from "#/model/conferencereport";
import { COMMON } from "#/const";

@Component({
  components: {
    BaseReportList
  }
})
export default class ConferenceEntry extends Mixins(AxiosMixin) {
  /** 差し戻し */
  private REPORT_REMAND = COMMON.REPORT_STATUS.REMAND;

  @Ref("reportList") private readonly reportList?: BaseReportList;

  private patientId = 0;

  private items: ConferenceReport[] = []; //会議録

  //会議録
  private headers: DataTableHeader[] = [
    {
      text: "会議日",
      value: "conference_date_wareki",
      align: "start",
      width: "152px",
      sort: SortWarekiDate
    },
    {
      text: "タイトル",
      value: "title",
      align: "start",
      width: "120px"
    }
  ];
  private commentHeader = {
    text: "コメント",
    value: "remand.comment"
  };

  public created(): void {
    this.patientId = Number(this.$route.params.id);
    // 未提出タブ以外ではタブ変更後の取得処理に任せる
    if (!this.$route.query.reporttab || this.$route.query.reporttab === "0") {
      this.fetchConferenceReport({ tab: 0, page: 0 });
    }
  }

  //新規作成
  private clickNew(): void {
    this.$router.push({
      name: "PatientConferenceEdit",
      params: { id: String(this.patientId), conferenceid: "0" }
    });
  }
  //編集
  private clickEdit(item: ConferenceReport): void {
    this.$router.push({
      name: "PatientConferenceEdit",
      params: { id: String(this.patientId), conferenceid: String(item.id) }
    });
  }

  //会議録情報一覧取得
  private fetchConferenceReport(obj: { tab: number; page: number }): void {
    this.postJsonCheck(
      window.base_url + "/api/patient/conferencereports/get",
      {
        patient_id: this.patientId,
        tab: obj.tab,
        page: obj.page
      },
      res => {
        if (res.data.items != null) {
          this.reportList?.finishLoaded(res.data.items);
          if (obj.page != 0) {
            this.items = this.items.concat(res.data.items);
          } else {
            this.items = res.data.items;
          }
        }
      }
    );
  }

  //差し戻し
  private setRemand(recordItem: {
    item: ConferenceReport;
    comment: string;
  }): void {
    recordItem.item.status = this.REPORT_REMAND;
    recordItem.item.remand.comment = recordItem.comment;
    this.postJsonCheck(
      window.base_url + "/api/patient/conferencereport/saveRemand",
      {
        conference_report: recordItem.item
      },
      () => {
        this.items = this.items.filter(v => v.id !== recordItem.item.id);
      }
    );
  }

  //PDF
  private pdf(item: ConferenceReport): void {
    this.makePdf(
      window.base_url + "/api/patient/conferencereport/preview/ids",
      {
        patient_id: this.patientId,
        conference_report_ids: [item.id],
        conference_reports: [item]
      }
    );
  }
}
